import React, { useEffect, useState } from 'react'
import { Error } from '../error/Error'
import { NoOption, OptionItem, OptionsList } from './style'
import { Input, Label, InputContainer } from '../input/style'
import { IDropdownProps } from '../../../types/interfaces/IDropdownProps'
import { useTranslation } from 'react-i18next'

export const Dropdown: React.FC<IDropdownProps> = ({
  hasError,
  errorText,
  callback,
  id,
  label,
  options,
  className,
  disabled,
  value,
  isRequired,
}) => {
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const [filteredOptions, setFilteredOptions] = useState<string[]>([])
  const [userInput, setUserInput] = useState<string>(value ?? '')

  const { t } = useTranslation('', {
    keyPrefix: 'components.dropdown',
  })

  useEffect(() => {
    setUserInput(value || '')
  }, [value])

  const onClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const target = e.target as HTMLLIElement
    setFilteredOptions(filteredOptions)
    setShowOptions(false)
    setUserInput(target.innerText)
    callback(target.innerText, false)
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = e.target.value
    // Filter our suggestions that don't contain the user's input
    const filteredOptions = options.filter((option: string) =>
      option.includes(userInput),
    )
    setUserInput(userInput)
    setFilteredOptions(filteredOptions)
    setShowOptions(true)
    if (filteredOptions.includes(userInput)) {
      callback(e.target.innerText, false)
    } else {
      callback(e.target.innerText, true)
    }
  }

  const renderOptionsListComponent = () => {
    return showOptions && userInput ? (
      filteredOptions.length ? (
        <OptionsList className={className}>
          {filteredOptions.map((option, index) => {
            let className
            return option !== 'לא פעיל' ? (
              <OptionItem
                className={className}
                key={`${option}${index}`}
                onClick={onClick}
              >
                {option}
              </OptionItem>
            ) : (
              <></>
            )
          })}
        </OptionsList>
      ) : (
        <NoOption className={className}>
          <em>{t('notFound')}</em>
        </NoOption>
      )
    ) : (
      <></>
    )
  }

  return (
    <>
      <InputContainer
        className={`dropdown ${className ?? ''} ${hasError ? 'error' : ''}`}
      >
        <Label htmlFor={id}>
          {label}
          {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Label>
        <Input
          className={className}
          disabled={disabled}
          id={id}
          type="text"
          onChange={onChange}
          value={userInput}
        ></Input>
        {renderOptionsListComponent()}
        <Error hasError={hasError} errorText={errorText}></Error>
      </InputContainer>
    </>
  )
}
export default Dropdown
